import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import CountdownTimer from './countdown-timer';
const SessionTimeoutComponent = ({ countdown, logout = undefined, logoutUrl, onActivity = () => { }, throttle = 300, // 5 minutes in seconds
timeout = 1080, // 18 minutes in seconds
 }) => {
    const [startCountdown, setStartCountdown] = useState(false);
    const handleOnAction = () => {
        onActivity();
    };
    const handleOnActive = () => {
        onActivity();
    };
    const handleOnIdle = () => {
        setStartCountdown(true);
    };
    const { reset } = useIdleTimer({
        timeout: timeout * 1000,
        onIdle: handleOnIdle,
        onActive: handleOnActive,
        onAction: handleOnAction,
        eventsThrottle: throttle * 1000,
    });
    return (_jsx(CountdownTimer, { countdown: countdown, logout: logout, logoutUrl: logoutUrl, reset: reset, setStartCountdown: setStartCountdown, startCountdown: startCountdown }));
};
export default SessionTimeoutComponent;
//# sourceMappingURL=session-timeout.js.map